export const ROUTE_LOGIN = "/login";
export const ROUTE_SIGN_UP_FLOW = "/forms/fresh-new-user";
